import styled, { css } from "styled-components";

const reusableBlocked = css`
  color: var(--red);
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  gap: 10px;
  pointer-events: none;
  cursor: not-allowed;

  .ant-tag {
    display: flex;
    width: max-content;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
`;

export const FooterButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
  flex-flow: row wrap;
  margin-top: 2em;
  margin-bottom: 2em;
  button {
    flex: 1 1 calc(300px - 1em);
  }
`;

export const MedBoxChecker = styled.div`
  width: 100%;
  background: #f5f5f5;
  border: 1px solid var(--accent);
  border-radius: 0.5em;
  overflow: hidden;
  margin-top: 2em;
  display: flex;
  flex-flow: column;
  gap: 0.6em;
  position: relative;

  & > div {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 0.6em;
  }

  .editContainer {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.6em;
    text-align: center;
  }

  .editContainer p {
    font-weight: 600;
    color: var(--accent);
    cursor: pointer;
  }

  .editContainer p.blocked {
    ${reusableBlocked}
  }

  .medName {
    display: flex;
    justify-content: center;
    background: var(--accent-mid);
    color: var(--accent);
    padding: 0.75em;
    text-align: center;
    font-weight: 600;
    flex-grow: 1 1 auto;
  }

  .medChangeDropdown {
    position: absolute;
    right: 10px;
    font-size: 24px;
    top: 3px;
  }
  .medName.blocked {
    ${reusableBlocked}
  }

  p {
    background: #fff;
    padding: 0.75em 1em;
    margin: 0;
    flex: 1 1 auto;

    span {
      display: block;
      width: 100%;
    }

    span.success {
      color: var(--green);
      font-weight: 600;
    }
    span.warn {
      color: var(--red);
      font-weight: 600;
    }
  }

  p.title {
    font-weight: 600;
    margin-top: -0.6em;
  }

  .batchList {
    width: 100%;
    grid-column: 1/5;
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 0.6em;

    .ant-tag {
      display: flex;
      width: max-content;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      margin-top: 8px;
    }
  }

  .batchListModal {
    width: 100%;
    grid-column: 1/5;
    display: flex;
    flex-flow: row wrap;
    gap: 0.6em;
    margin-bottom: 1em;

    :last-child {
      margin-bottom: 0;
    }

    & p:first-child {
      flex: 1 1 60%;

      @media (max-width: 768px) {
        display: flex;
        justify-content: space-between;
        align-items: center;

        & span {
          width: auto;
        }
      }
    }

    & p:nth-child(2) {
      flex: 1 1 auto;
    }

    & p:nth-child(3),
    p:last-child {
      flex: 1 1;
    }

    & .ant-select-arrow {
      width: auto !important;
    }
  }
`;

export const MedBoxCheckerNew = styled.div`
  width: 100%;
  background: #f5f5f5;
  border: 1px solid var(--accent);
  border-radius: 0.5em;
  overflow: hidden;
  margin-top: 2em;
  display: flex;
  flex-flow: column;
  gap: 0.6em;

  & > div {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 0.6em;
  }

  .editContainer {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.6em;
    text-align: center;
  }

  .editContainer p {
    font-weight: 600;
    color: var(--accent);
    cursor: pointer;
  }

  .medName {
    display: flex;
    justify-content: center;
    background: var(--accent-mid);
    color: var(--accent);
    padding: 0.75em;
    text-align: center;
    font-weight: 600;
    flex-grow: 1 1;
  }

  p {
    background: #fff;
    padding: 0.75em 1em;
    margin: 0;
    flex: 1 1;

    span {
      display: block;
      width: 100%;
    }

    span.success {
      color: var(--green);
      font-weight: 600;
    }
    span.warn {
      color: var(--red);
      font-weight: 600;
    }
  }

  p.title {
    font-weight: 600;
    margin-top: -0.6em;
  }

  .batchList {
    width: 100%;
    grid-column: 1/5;
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 0.6em;
  }

  .batchListModal {
    width: 100%;
    grid-column: 1/5;
    display: flex;
    flex-flow: row wrap;
    gap: 0.6em;
    margin-bottom: 1em;

    :last-child {
      margin-bottom: 0;
    }

    & p:first-child {
      flex: 1 1;

      @media (max-width: 768px) {
        display: flex;
        justify-content: space-between;
        align-items: center;

        & span {
          width: auto;
        }
      }
    }

    & p:nth-child(2) {
      flex: 1 1;
    }

    & p:nth-child(3),
    p:last-child {
      flex: 1 1;
    }

    & .ant-select-arrow {
      width: auto !important;
    }
  }
`;

export const MedIssueModalWrapperPicker = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  gap: 1em;
`;

export const PreviewWrapper = styled.div`
  iframe {
    width: 100%;
    height: 60vh;
    border-radius: 4px;
  }
`;
